"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserProvider = void 0;
const browser_s3_provider_1 = require("./browser-s3-provider");
const cookie_provider_1 = require("./cookie-provider");
const defaults_provider_1 = require("./defaults-provider");
const error_fallback_provider_1 = require("./error-fallback-provider");
const query_string_provider_1 = require("./query-string-provider");
class BrowserProvider {
    constructor(app) {
        this.app = app;
    }
    async apply(props) {
        return [
            ...new error_fallback_provider_1.ErrorFallbackProvider().apply(props),
            ...new defaults_provider_1.DefaultsProvider().apply(props),
            ...(await new browser_s3_provider_1.BrowserS3Provider(this.app).apply(props)),
            ...new cookie_provider_1.CookieProvider(this.app, document.cookie).apply(props),
            ...new query_string_provider_1.QueryStringProvider(this.app, location.search).apply(props),
        ];
    }
}
exports.BrowserProvider = BrowserProvider;
//# sourceMappingURL=browser-provider.js.map